var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"prematch-nav"},[_c('button',{class:{ 'prematch-nav__item': 1, active: _vm.selectedNav === '' },on:{"click":function($event){return _vm.changeNav('')}}},[_vm._v("\n\t\t"+_vm._s(_vm.$t("prebets.highlights"))+"\n\t")]),_vm._v(" "),_c('button',{class:{ 'prematch-nav__item': 1, active: _vm.selectedNav === 'upcoming' },on:{"click":function($event){return _vm.changeNav('upcoming')}}},[_vm._v("\n\t\t"+_vm._s(_vm.$t("prebets.upcoming"))+"\n\t")]),_vm._v(" "),(_vm.selectedSport)?_c('router-link',{class:{
			'prematch-nav__item': 1,
			active: _vm.$route.name === 'sport-countries',
		},attrs:{"to":{
			name: 'sport-countries',
			params: {
				sportName: _vm.$options.filters.seoText(_vm.selectedSport.sport_name),
			},
		}}},[_vm._v("\n\t\t"+_vm._s(_vm.$t("prebets.countries"))+"\n\t")]):_vm._e(),_vm._v(" "),(_vm.$store.getters.layout == 'Mobile' && _vm.env.showPreMatchNavItem)?_c('button',{class:{ 'prematch-nav__item': 1, active: _vm.selectedNav === 'jackpots' },on:{"click":function($event){return _vm.openRoute('/jackpots/midweekjp')}}},[_vm._v("\n\t\t"+_vm._s(_vm.$t("overlay-menu.jackpots"))+"\n\t")]):_vm._e(),_vm._v(" "),(_vm.showEsports && !_vm.env.showTopSoccerLeaguesFilter)?_c('button',{class:{
			'prematch-nav__item': 1,
			active: _vm.selectedNav === 'quick-e',
		},on:{"click":function($event){return _vm.changeNav('quick-e')}}},[_vm._v("\n\t\t"+_vm._s(_vm.$t("prebets.quick-e"))+"\n\t")]):_vm._e(),_vm._v(" "),(_vm.env.showTopSoccerLeaguesFilter && _vm.selectedSport.sport_name.toLowerCase() === 'soccer')?_c('router-link',{class:{
			'prematch-nav__item': 1,
			active: _vm.$route.name === 'sport-leagues',
		},attrs:{"to":{
			name: 'sport-leagues',
			params: {
				sportName: _vm.$options.filters.seoText(_vm.selectedSport.sport_name),
			},
		}}},[_vm._v("\n\t\t"+_vm._s(_vm.$t("prebets.top-leagues"))+"\n\t")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }